/**
 * Helpers purs — `ExtractedFieldEditor` (9.T.5.v3.3 relocation neutre).
 *
 * Module **pur** (zéro dépendance React/API/Supabase/window) — extrait en 9.M.1
 * pour permettre des tests Node sans DOM. Sémantique strictement inchangée
 * vs l'implémentation legacy `pages/submissions/_parts/extractedFieldEditorHelpers.ts`.
 *
 * Règle PO 9.C — sérialisation de `value` :
 *   1. trim → si commence par `{` ou `[` → tente `JSON.parse`
 *      • succès → `{ ok: true, value: <parsed> }`
 *      • échec → `{ ok: false }`  (handler bloque submit + i18n
 *        `error_invalid_json`)
 *   2. sinon → `{ ok: true, value: <raw string telle quelle> }`
 */

export function looksLikeJson(raw: string): boolean {
  const t = raw.trim();
  return t.startsWith("{") || t.startsWith("[");
}

export function parseEditorValue(raw: string): { ok: true; value: unknown } | { ok: false } {
  if (looksLikeJson(raw)) {
    try {
      return { ok: true, value: JSON.parse(raw) };
    } catch {
      return { ok: false };
    }
  }
  return { ok: true, value: raw };
}
